// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"S1-z","trustedRetailerTooltipWrapper":"T1-z"};